export default function CTAHero() {
  return (
    <div
      className="h-96 relative"
      style={{ backgroundImage: 'url("/hero.jpg")' }}
    >
      <div className="bg-black/40 absolute top-0 right-0 bottom-0 left-0" />
      <div className="z-10 absolute left-0 right-0 bottom-0 top-0 flex items-center justify-center flex-col">
        <span className="text-white">Join us</span>
        <h1 className="text-white text-center leading-10 text-4xl font-bold">Join the best procurement <br /> network in Asia</h1>
      </div>
    </div>
  );
}
